<!--
 * @Author: ZhaoG
 * @Date: 2025-05-09 14:06:19
 * @LastEditors: ZhaoG
 * @LastEditTime: 2025-09-11 15:30:33
 * @FilePath: \gcp-fe\src\app\procurementNotice\components\table.vue
 * @Description: 采购公告--表格查询
-->
<template>
  <div>
    <!--table表格区域Begin-->
    <div class="ccui-multifunctional-table-wrapper mt20">
      <el-table
        :data="tableData"
        header-cell-class-name="table_header"
        :border="false"
        :row-style="{ height: 0 }"
        style="width: 100%; margin-top: 20px; padding: 0 0 10px 0"
        :empty-text="$t('page.content.noData')"
      >
        <el-table-column
          type="index"
          :label="$t('page.content.serialNo')"
          width="50"
          align="center"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          prop="schemeCode"
          :label="$t('page.content.purchaseNo')"
          :width="codeWidth"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="{ row }">
            <el-button
              class="column-btn-ellipsis"
              size="mini"
              type="text"
              @click="handleView(row)"
            >
              {{ row.schemeCode }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column
          prop="noticeTitle"
          :label="$t('page.content.title')"
          width="260"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="{ row }">
            {{ row.noticeTitle }}
          </template>
        </el-table-column>
        <el-table-column
          prop="provinceName"
          :label="$t('page.content.provinceCity')"
          width="80"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="{ row }">
            {{ row.provinceName }}
          </template>
        </el-table-column>
        <el-table-column
          prop="matBigClassesNameStr"
          :label="$t('page.content.category')"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="{ row }">
            {{ row.matBigClassesNameStr }}
          </template>
        </el-table-column>
        <el-table-column
          prop="mergePurchaseTypeName"
          :label="$t('page.content.purchaseType')"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="{ row }">
            {{ row.mergePurchaseTypeName }}
          </template>
        </el-table-column>
        <el-table-column
          prop="noticeReleaseTime"
          :label="$t('page.content.publishTime')"
        >
        </el-table-column>
        <el-table-column
          prop="singUpDeadline"
          :label="$t('page.content.ApplicationTime')"
        >
        </el-table-column>
        <el-table-column
          prop="signUpStatusName"
          :label="$t('page.content.status')"
          width="80"
        >
          <template slot-scope="{ row }">
            <span
              :class="{
                statusBox:
                  row.signUpStatusName == '报名中' ||
                  row.signUpStatusName == '公示中'
              }"
              >{{ row.signUpStatusName }}</span
            >
          </template>
        </el-table-column>
      </el-table>
      <!--分页Begin-->
      <div
        class="ccui-table-footer"
        v-show="tableData.length > 0"
        style="padding-bottom: 20px"
      >
        <div id="ccui-paging">
          <el-pagination
            :total="pageTotal"
            :page-size="pageSize"
            :current-page="pageNo"
            :page-sizes="[10, 20, 50, 100, 200, 500]"
            background
            layout="total, sizes, prev, pager, next, jumper"
            popper-class="ccui-paging-page-size-popper"
            @prev-click="handlePrev"
            @next-click="handleNext"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          />
          <el-button
            class="ccui-pagination-btn"
            size="mini"
            type="default"
            @click="handleSizeChange('none')"
            >{{ $t("page.content.sure") }}</el-button
          >
        </div>
      </div>
      <!--分页End-->
    </div>
    <!--table表格区域End-->
  </div>
</template>

<script>
import Cookies from "js-cookie";
import {
  // searchSupBidNotice,
  qryEsNoticePageList
} from "@/app/shop/api/shoppingSP";
import { decryptField } from "@/mixins/mixin-common/fieldDecryptor";
import moment from "moment";
import { mixinHomePage } from "@/mixins/mixin-common/mixin-homePage";
import createFormOptions from "../js/formOptions";

export default {
  name: "GcpFeTable",
  mixins: [mixinHomePage],
  props: {
    active: {
      type: Number,
      default: 0
    },
    noticeTime: {
      type: Array,
      default: () => []
    },
    form: {
      type: Object,
      default: () => {}
    }
  },

  data() {
    return {
      formOptions: createFormOptions(),
      moment,
      tableData: [],
      pageNo: 1,
      pageSize: 10,
      pageTotal: 0,
      openId: "",
      schemeClass: null,
      codeWidth: 200
    };
  },

  mounted() {
    this.openId = Cookies.get("access_token");
    this.init();
  },

  computed: {
    queryParams() {
      return {
        active: this.active,
        noticeTime: this.noticeTime,
        form: this.form
      };
    }
  },

  watch: {
    queryParams: {
      handler() {
        this.pageNo = 1;
        this.pageSize = 10;
        this.pageTotal = 0;
        this.init();
      },
      deep: true
    }
  },

  // watch: {
  //   // tab标签
  //   active: {
  //     handler(val) {
  //       // if (val == 4) {
  //       //   this.codeWidth = 200;
  //       // } else {
  //       //   this.codeWidth = 160;
  //       // }
  //       this.pageNo = 1;
  //       this.pageSize = 10;
  //       this.pageTotal = 0;
  //       this.init();
  //     },
  //     deep: true,
  //     immediate: true
  //   },
  //   // 发布时间
  //   noticeTime: {
  //     handler(val) {
  //       this.init();
  //     }
  //   },
  //   //公告类型
  //   "form.noticeType": {
  //     handler(val) {
  //       this.init();
  //     }
  //   },
  //   //省份
  //   "form.provinceList": {
  //     handler(val) {
  //       this.init();
  //     }
  //   },
  //   //采购分类
  //   "form.purchaseCategoryList": {
  //     handler(val) {
  //       this.init();
  //     }
  //   },
  //   // 物资分类
  //   "form.matBigClassesList": {
  //     handler(val) {
  //       this.init();
  //     }
  //   },
  //   // 采购方式
  //   "form.mergePurchaseTypeList": {
  //     handler(val) {
  //       this.init();
  //     }
  //   },
  //   // 状态
  //   "form.singUpStatus": {
  //     handler(val) {
  //       this.init();
  //     }
  //   },
  //   // 公告名称
  //   "form.noticeTitle": {
  //     handler(val) {
  //       this.init();
  //     }
  //   },
  //   // 分包类型
  //   "form.subcontractingTypeList": {
  //     handler(val) {
  //       this.init();
  //     }
  //   },
  //   // 工程分包-类别
  //   "form.subcontractingCategoryList": {
  //     handler(val) {
  //       this.init();
  //     }
  //   },
  //   // 工程分包-组织机构
  //   "form.opUnitId": {
  //     handler(val) {
  //       this.init();
  //     }
  //   },
  //   // 是否海外采购
  //   "form.overseasPurchaseFlag": {
  //     handler(val) {
  //       this.init();
  //     }
  //   }
  // },

  methods: {
    init() {
      // 公共的参数
      let param = {
        isShowLoading: true,
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        noticeType: this.form.noticeType, //公告类型
        mergePurchaseTypeList: this.form.mergePurchaseTypeList, //采购方式
        noticeTitle: this.form.noticeTitle, //公告名称
        singUpStatus: this.form.singUpStatus, //状态
        dataSourceFlag: this.active == 4 ? 2 : null, //工程分包 当选中工程分包时传值为2
        keyWord: sessionStorage.getItem("searchName") || ""
      };
      //发布时间
      if (this.noticeTime && this.noticeTime.length !== 0) {
        param.noticeTimeStart = this.noticeTime[0];
        param.noticeTimeEnd = this.noticeTime[1];
      }
      //采购类型
      if (this.active == 0 || this.active == 4) {
        param.schemeClass = null;
      } else {
        param.schemeClass = this.active - 1;
      }

      let params = {};
      if (this.active == 0) {
        if (this.form.noticeType == 0 || this.form.noticeType == 1) {
          params = {
            provinceList: this.form.provinceList //省份
          };
        } else {
          params = {
            provinceList: null //省份
          };
        }
      } else if (this.active == 1 || this.active == 2) {
        params = {
          provinceList: this.form.provinceList, //省份
          purchaseCategoryList: this.form.purchaseCategoryList, //采购分类
          matBigClassesList: this.form.matBigClassesList, //物资分类
          overseasPurchaseFlag:
            this.form.overseasPurchaseFlag == -1
              ? null
              : this.form.overseasPurchaseFlag //是否海外采购
        };
      } else if (this.active == 3) {
        params = {
          provinceList: this.form.provinceList, //省份
          purchaseCategoryList: this.form.purchaseCategoryList, //采购分类
          overseasPurchaseFlag:
            this.form.overseasPurchaseFlag == -1
              ? null
              : this.form.overseasPurchaseFlag //是否海外采购
        };
      } else if (this.active == 4) {
        params = {
          provinceList: this.form.provinceList, //省份
          purchaseCategoryList: this.form.purchaseCategoryList, //采购分类
          subcontractingTypeList: this.form.subcontractingTypeList, //工程分包 分包类型
          subcontractingCategoryList: this.form.subcontractingCategoryList, //工程分包  类别
          opUnitId: this.form.opUnitId //工程分包  组织机构 采购组织
        };
      }

      // params = {
      //   pageNo: this.pageNo,
      //   pageSize: this.pageSize,
      //   noticeType: this.form.noticeType, //公告类型
      //   provinceList: this.form.provinceList, //省份
      //   purchaseCategoryList: this.form.purchaseCategoryList, //采购分类
      //   matBigClassesList: this.form.matBigClassesList, //物资分类
      //   mergePurchaseTypeList: this.form.mergePurchaseTypeList, //采购方式
      //   singUpStatus: this.form.singUpStatus, //状态
      //   noticeTitle: this.form.noticeTitle, //公告名称
      //   schemeClass: this.schemeClass, //采购类型
      //   dataSourceFlag: this.active == 4 ? 2 : null, //工程分包 当选中工程分包时传值为2
      //   subcontractingTypeList:
      //     this.active == 4 ? this.form.subcontractingTypeList : null, //工程分包 分包类型
      //   subcontractingCategoryList:
      //     this.active == 4 ? this.form.subcontractingCategoryList : null, //工程分包 类别
      //   opUnitId: this.active == 4 ? this.form.opUnitId : null, //工程分包 组织机构
      //   overseasPurchaseFlag:
      //     this.form.overseasPurchaseFlag == -1
      //       ? null
      //       : this.form.overseasPurchaseFlag, //是否海外采购
      // };
      let paramsData = Object.assign(params, param);
      qryEsNoticePageList(paramsData).then(res => {
        if (res.data.code === "0") {
          let data = JSON.parse(JSON.stringify(res.data.data.rows));
          data.forEach(item => {
            // 这里循环一下单条item里面所有的key,如果value有值，并且是字符串，里面带有enc:开头的，全部给他解密，
            for (let key in item) {
              if (
                item[key] &&
                typeof item[key] == "string" &&
                item[key].startsWith("enc:")
              ) {
                item[key] = this.decryptCell(item[key]);
              }
            }
            if (item.noticeReleaseTime) {
              item.noticeReleaseTime = item.noticeReleaseTime.substring(0, 16);
            }
            if (item.singUpDeadline) {
              item.singUpDeadline = item.singUpDeadline.substring(0, 16);
            }
            item.noticeTypeName = this.formOptions.typeOptions.filter(
              item => item.value == this.form.noticeType
            )[0].label;
            item.noticeType = this.form.noticeType;
          });

          this.tableData = data;
          this.pageTotal = res.data.data.recordsTotal;
          this.total = res.data.data.total;
        }
      });
    },

    /**
     * 同步解密单元格（从缓存读取）
     */
    decryptCell(value) {
      return decryptField(value);
    },

    //登录
    handleLogin() {
      window.location.href =
        this.$addUrlPerFix(process.env.VUE_APP_LOGIN) +
        "?redirectUrl=" +
        encodeURIComponent(this.$addUrlPerFix(process.env.VUE_APP_BASE_URL));
    },
    // 新用户注册
    handleRegister() {
      // 跳转注册页面
      window.location.href = `${this.$addUrlPerFix(
        process.env.VUE_APP_SRA_URL
      )}/index`;
    },
    cellStyle({ row, column, rowIndex, columnIndex }) {
      // 判断高亮行
      return { color: "#0089EF", cursor: "pointer" };
    },

    getList(obj) {
      this.init();
    },
    handlePrev() {
      --this.pageNo;
      let obj = {
        pageNo: this.pageNo,
        pageSize: this.pageSize
      };
      this.getList(obj);
    },
    handleNext() {
      ++this.pageNo;
      let obj = {
        pageNo: this.pageNo,
        pageSize: this.pageSize
      };
      this.getList(obj);
    },
    handleSizeChange(val) {
      this.pageNo = 1;
      if (val !== "none") {
        this.pageSize = val;
        // setSessionItem("pageSize", this.tableName, val);
      }
      let obj = {
        pageNo: this.pageNo,
        pageSize: this.pageSize
      };
      this.getList(obj);
    },
    handleCurrentChange(val) {
      // let searchFormData = getSessionItem("pageNo", this.tableName) || {};
      // setSessionItem("pageNo", this.tableName, {
      //   pageNo: val,
      //   searchForm: searchFormData.searchForm || {}
      // });
      this.pageNo = val;
      let obj = {
        pageNo: this.pageNo,
        pageSize: this.pageSize
      };
      this.getList(obj);
    }
  }
};
</script>

<style scoped lang="scss">
/deep/
  .ccui-multifunctional-table-wrapper
  .el-table
  .el-table__header
  thead
  tr {
  background: #edf4f9;
}
/deep/
  .ccui-multifunctional-table-wrapper
  .el-table
  .el-table__header
  thead
  th {
  background: #edf4f9;
}
/deep/ .ccui-multifunctional-table-wrapper .el-table__header-wrapper th {
  border-right: 2px solid #edf4f9;
}

.logOutBox {
  background-color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 30px 0;
  margin-top: 20px;

  p {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #737373;
    margin: 25px 0;
  }

  .btn1 {
    cursor: pointer;
    margin-left: 16px;
    margin-right: 10px;
    width: 109px;
    height: 32px;
    border-radius: 4px;
    background: #ffffff;
    color: #0089ef;
    border: 1px solid #0089ef;
    font-size: 13px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
  }

  .btn2 {
    cursor: pointer;
    width: 109px;
    height: 32px;
    background: #0089ef;
    border-radius: 4px;
    font-size: 13px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    border: 1px solid #0089ef;
    color: #ffffff;
  }
}

.statusBox {
  color: #149982;
}
</style>
